/*
 * Produktkortets pris og lagerstatus følger den valgte farve.
 *
 * Kortet rendres med produktets laveste pris ("Fra 94,00 kr"), og temaet
 * opdaterer kun billedet og linket, når kunden vælger en farve. Priserne er
 * forskellige fra farve til farve, så kortet viste et andet beløb end
 * produktsiden. Farvens pris ligger færdigformateret på selve radioknappen
 * (data-price-html fra card-swatch.liquid) - her flyttes den bare ind i
 * priselementet.
 *
 * Lytteren sidder på document, så den også fanger kort, der kommer ind bagefter
 * (filtrering, "vis flere", quick view), uden at vi skal hooke ind i main.js.
 */
(() => {
  const setValue = (el, html) => {
    if (el && el.innerHTML !== html) el.innerHTML = html;
  };

  document.addEventListener('change', (evt) => {
    const input = evt.target;
    if (!input || typeof input.matches !== 'function' || !input.matches('.opt-btn')) return;

    const priceHtml = input.dataset.priceHtml;
    const stockHtml = input.dataset.stockHtml;
    if (!priceHtml && !stockHtml) return;

    const card = input.closest('product-card') || input.closest('.card');
    if (!card) return;

    // Lagerstatus hører til farven lige så meget som prisen gør: en farve kan
    // være i restordre, mens naboen ligger på hylden. Markup'en er rendret
    // færdig på serveren, så der skiftes blot ud.
    if (stockHtml) {
      const stockEl = card.querySelector('.stock-status');
      if (stockEl && stockEl.outerHTML !== stockHtml) stockEl.outerHTML = stockHtml;
    }

    if (!priceHtml) return;

    const compareHtml = input.dataset.compareHtml || '';
    const varies = input.dataset.priceVaries === 'true';

    card.querySelectorAll('.price--top, .price--bottom').forEach((priceEl) => {
      setValue(priceEl.querySelector('.price__current .js-value'), priceHtml);
      setValue(priceEl.querySelector('.price__was .js-value'), compareHtml);

      // "Fra" hører kun til, hvis netop denne farve stadig har flere priser.
      const from = priceEl.querySelector('.price__from');
      if (from) from.style.display = varies ? '' : 'none';

      priceEl.classList.toggle('price--on-sale', compareHtml !== '');
    });
  });
})();
